import { render, staticRenderFns } from "./CTTAreaPromoter.vue?vue&type=template&id=695ab5de"
import script from "./CTTAreaPromoter.vue?vue&type=script&lang=js"
export * from "./CTTAreaPromoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports